
import {
  NgModule
} from '@angular/core';

import {
  FormsModule
} from '@angular/forms';

import {
  BrowserModule
} from '@angular/platform-browser';

import {
  HttpClientModule
} from '@angular/common/http';

import {
  MatButtonModule
} from '@angular/material/button';

import {
  MatFormFieldModule
} from '@angular/material/form-field';

import {
  MatIconModule
} from '@angular/material/icon';

import {
  MatInputModule
} from '@angular/material/input'

import {
  MatSelectModule
} from '@angular/material/select';

import {
  NbActionsModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbIconModule,
  NbLayoutModule,
  NbListModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToggleModule
} from '@nebular/theme';

import {
  HeaderModule,
  LanguageSelectModule,
  OrderedListModule,
  WysiwygModule
} from '../../components';

import {
  AppRoutingModule
} from '../../app/app-routing.module';

import {
  AuthService,
  PricelistService,
  ServiceService
} from '../../providers';

import {
  PricelistComponent
} from './pricelist.component';

@NgModule({
  declarations: [
    PricelistComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    NbActionsModule,
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbDatepickerModule,
    NbIconModule,
    NbLayoutModule,
    NbListModule,
    NbSelectModule,
    NbSpinnerModule,
    NbToggleModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    HeaderModule,
    LanguageSelectModule,
    OrderedListModule,
    WysiwygModule,
    AppRoutingModule
  ],
  providers: [
    AuthService,
    PricelistService,
    ServiceService
  ]
})
export class PricelistModule { }
